export default "__VITE_ASSET__DiQl2OIZ__"